export enum TextAdditionalTimesEnum {
        One = 2120,
        Two = 2121,
        Three = 2122,
        Four = 2123,
        Five = 2124,
}
